<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>DMP Klimatilpasningsdashboard frontend template</p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<style scoped>
.hello {
  padding: 2rem;
}

h1 {
  margin-bottom: 0.5rem;
}

p {
  color: #52606d;
}
</style>
